import React from 'react';
import s from './Login.module.css';

const Login = () => {
    return(
        <div className={s.login}>
            Login
        </div>
    )
}

export default Login;